<div class="panel-options-body overflow-wrapper theme-setting-panel">
    <div class="mb-20">
        <label>{{ "theme_settings_color_scheme" | translate }}</label>
        <a class="dotted pull-right" (click)="openDetailSettingsView(ThemeSettings.colorsSettings)">
            {{ "theme_settings_customize" | translate }}
        </a>
        <div class="form-control preset-control" dropdown container="body">
            <ul class="color-elements" dropdownToggle>
                @for (color of selectedThemeColors(); track color.name) {
                    <li>
                        <div class="color-element" [style.background]="color.value">
                            <sp-transparent-icon [color]="color.value" />
                        </div>
                    </li>
                }
            </ul>

            <ul class="dropdown-menu preset-wrapper scroll-wrapper" *dropdownMenu>
                @for (colorTemplate of colorsPresets(); track colorTemplate.index) {
                    <li>
                        <ul
                            class="color-elements"
                            [class.selected]="selectedThemeColorIndex() === colorTemplate.index"
                            (click)="selectColorsThemeHandler(colorTemplate)"
                        >
                            @for (color of colorTemplate.values; track color.name) {
                                <li>
                                    <div class="color-element" [style.background]="color.value">
                                        <sp-transparent-icon [color]="color.value" />
                                    </div>
                                </li>
                            }
                        </ul>
                    </li>
                }
            </ul>
        </div>
    </div>

    <div class="mb-20">
        <label>{{ "theme_settings_font_text_styles" | translate }}</label>
        <a class="dotted pull-right" (click)="openDetailSettingsView(ThemeSettings.fontsSettings)">
            {{ "theme_settings_customize" | translate }}
        </a>
        <div class="form-control preset-control scroll-wrapper" dropdown container="body">
            <div class="font-elements" dropdownToggle>
                <div class="font-element title-style">
                    <span class="font-weight-bold" [style.font-family]="currentFonts().h1.family">
                        {{ currentFonts().h1.name }}
                    </span>
                    <div>
                        <span class="font-element-size">h1</span>
                        <span class="font-element-size">{{ currentFonts().h1.size }}</span>
                    </div>
                </div>
                <div class="font-element paragraph-style">
                    <span [style.font-family]="currentFonts().p.family">
                        {{ currentFonts().p.name }}
                    </span>
                    <div>
                        <span class="font-element-size">p</span>
                        <span class="font-element-size">{{ currentFonts().p.size }}</span>
                    </div>
                </div>
            </div>

            <ul class="dropdown-menu preset-wrapper scroll-wrapper" *dropdownMenu>
                @for (preview of fontPresetPreviews(); track preview.index) {
                    <li>
                        <div
                            class="font-elements default-elements"
                            [class.selected]="selectedThemeFontIndex() === preview.index"
                            (click)="selectFontsThemeHandler(preview.preset)"
                        >
                            <div class="font-element title-style">
                                <span class="font-weight-bold" [style.font-family]="preview.fonts.h1.family">
                                    {{ preview.fonts.h1.name }}
                                </span>
                                <div>
                                    <span class="font-element-size">h1</span>
                                    <span class="font-element-size">{{ preview.fonts.h1.size }}</span>
                                </div>
                            </div>
                            <div class="font-element paragraph-style">
                                <span [style.font-family]="preview.fonts.p.family">
                                    {{ preview.fonts.p.name }}
                                </span>
                                <div>
                                    <span class="font-element-size">p</span>
                                    <span class="font-element-size">{{ preview.fonts.p.size }}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        </div>
    </div>

    <div>
        <label>{{ "theme_settings_buttons" | translate }}</label>
        <a class="dotted pull-right" (click)="openDetailSettingsView(ThemeSettings.buttonsSettings)">
            {{ "theme_settings_customize" | translate }}
        </a>
        <div class="form-control preset-control" dropdown container="body">
            <div class="button-elements" dropdownToggle>
                @for (selectedButtonPreset of selectedThemeButtons(); track selectedButtonPreset.styleType) {
                    <sp-theme-button-preset class="button-element" [selected]="true" [button]="selectedButtonPreset" />
                }
            </div>

            <ul class="dropdown-menu preset-wrapper scroll-wrapper" *dropdownMenu>
                @for (buttonPreset of buttonsPresets(); track buttonPreset.index) {
                    <li>
                        <div
                            class="button-elements default-elements"
                            [class.selected]="selectedThemeButtonIndex() === buttonPreset.index"
                            (click)="selectButtonsThemeHandler(buttonPreset)"
                        >
                            @for (button of buttonPreset.values; track button.styleType) {
                                <sp-theme-button-preset class="button-element" [button]="button" />
                            }
                        </div>
                    </li>
                }
            </ul>
        </div>
    </div>
</div>
